import { sanitizeDecimalKeystrokes } from "../lib/decimal";

// `input` sinifi index.css'te tanimli; tum formlarda ayni gorunum icin onu kullaniriz.
const BASE = "input text-right tabular-nums read-only:bg-gray-50 read-only:text-gray-600";

interface NumericInputProps {
  value: string;
  onChange: (v: string) => void;
  id?: string;
  name?: string;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  "aria-label"?: string;
  onBlur?: () => void;
}

/**
 * Ondalık giriş alanı — Türkçe virgül kabul eder.
 *
 * `type="number"` KULLANILMAZ: tarayıcı yerel ayara göre virgülü reddedebiliyor
 * ve kullanıcı 12,50 yazamıyor. `inputMode="decimal"` mobilde sayısal tuş takımını
 * açar, doğrulama bize kalır (bkz. `lib/decimal.ts`).
 */
export function DecimalInput({
  value,
  onChange,
  className = "",
  ...rest
}: NumericInputProps) {
  return (
    <input
      type="text"
      inputMode="decimal"
      lang="tr"
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(sanitizeDecimalKeystrokes(e.target.value))}
      className={`${BASE} ${className}`}
      {...rest}
    />
  );
}

/**
 * Para giriş alanı. Görsel olarak ₺ eki taşır; ayrıştırma DecimalInput ile aynıdır.
 * Değer daima METİN olarak taşınır; kuruşa çevrim `parseKurus()` ile kaydetme
 * anında yapılır — böylece kullanıcı yazarken ara değerler bozulmaz.
 */
export function MoneyInput({
  value,
  onChange,
  className = "",
  ...rest
}: NumericInputProps) {
  return (
    <div className="relative">
      <input
        type="text"
        inputMode="decimal"
      lang="tr"
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(sanitizeDecimalKeystrokes(e.target.value))}
        className={`${BASE} pr-8 ${className}`}
        {...rest}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-sm text-gray-500"
      >
        ₺
      </span>
    </div>
  );
}

export default DecimalInput;
